import React from "react";
import Cards from "./Cards";

const Container = () => {
  return (
    <div className="container border my-3">
      <Cards />
    </div>
  );
};

export default Container;
